/**
 * Function to convert UTC time to date in the system's local time zone
 * @param utcString - The UTC string to convert
 * @returns - The date in the local time zone
 */
function ConvertTimeToDate(utcString: string) {
    const [time, modifier] = utcString.split(" "); // Split time and AM/PM
    let [hours, minutes] = time.split(":").map(Number); // Extract hours & minutes

    if (modifier === "PM" && hours !== 12) {
        hours += 12;
    }
    if (modifier === "AM" && hours === 12) {
        hours = 0;
    }

    minutes = minutes + 1 - 1;

    // Create a new Date object with today's date
    const now = new Date();
    now.setHours(hours, minutes, 0, 0);

    return now;
}

export default ConvertTimeToDate;
